<template>
  <v-container fluid>
    <v-card class="ui-module-card ui-module-fade-in-up trainers-shell" color="primary">
      <v-card-text>
        <v-row>
          <v-col cols="7" align="right">
            <TextButton
              class="secondary ui-module-btn-solid ui-module-fade-in-up py-y mt-2 px-8"
              rounded
              elevation="8"
              to="/profesionalizacion/registro_capacitador"
              >Nuevo capacitador <v-icon small class="ml-2">mdi-plus</v-icon></TextButton
            >
          </v-col>
          <v-col cols="12" lg="5">
            <v-text-field
              class="ui-form-field"
              v-model="buscaCapacitador"
              color="secondary"
              background-color="transparent"
              rounded
              filled
              hide-details
              :placeholder="searchPlaceholder"
              append-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="pb-2">
            <v-tabs v-model="registroTab" color="secondary">
              <v-tab>Capacitadores</v-tab>
              <v-tab>Institución responsable</v-tab>
            </v-tabs>
          </v-col>
        </v-row>
        <v-row v-if="currentItems.length > 0">
          <v-col cols="12" v-if="buscaCapacitador.length > 0">
            <div class="text-h6 font-weight-bold">
              {{ currentItems.length }} resultados encontrados con la búsqueda "{{ buscaCapacitador }}"
            </div>
          </v-col>
          <v-col cols="12">
            <v-data-table
              class="transparent ui-module-table no-table-bg"
              :headers="currentHeaders"
              :items="currentItems"
              calculate-widths
            >
              <template v-slot:[`item.segundoNombre`]="{ item }">
                {{ item.segundoNombre || '' }}
              </template>
              <template v-slot:[`item.adjunto`]="{ item }">
                <v-btn v-if="item.URL" text small color="secondary" @click="downloadFile(item.URL)">
                  Ver adjunto
                </v-btn>
                <span v-else>-</span>
              </template>
              <template v-slot:[`item.opciones`]="{ item }">
                <v-tooltip bottom color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :to="{ name: 'updateTrainer', params: { id: item.id } }"
                      class="secondary--text ui-module-icon-action"
                      icon
                      v-on="on"
                      v-bind="attrs"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar capacitador</span>
                </v-tooltip>
              </template>
              <template v-slot:no-data>
                <div class="text-h6 justify-center" align="center">
                  {{ emptyMessage }}
                </div>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12" align="center">
            <div class="text-h4">{{ emptyMessage }}</div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
import TextButton from '@/components/base/TextButton.vue'
import fileDownloadMixin from '@/mixins/fileDownloadMixin'

export default {
  components: {
    TextButton,
  },
  mixins: [fileDownloadMixin],
  data() {
    return {
      buscaCapacitador: '',
      ordenAlfabetico: 0,
      tipoRegistro: 'capacitador',
      capacitadoresHeaders: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Segundo nombre', value: 'segundoNombre' },
        { text: 'Apellido paterno', value: 'apaterno' },
        { text: 'Apellido materno', value: 'amaterno' },
        { text: 'Adjunto', value: 'adjunto', sortable: false, align: 'center' },
        { text: 'Opciones', value: 'opciones', sortable: false, align: 'center' },
      ],
      institucionesHeaders: [
        { text: 'Nombre de la institución', value: 'nombre' },
        { text: 'Adjunto', value: 'adjunto', sortable: false, align: 'center' },
        { text: 'Opciones', value: 'opciones', sortable: false, align: 'center' },
      ],
    }
  },

  computed: {
    ...mapState('capacitador', {
      registrosCapacitadores: (state) => state.capacitadores,
    }),

    registroTab: {
      get() {
        return this.tipoRegistro === 'capacitador' ? 0 : 1
      },
      set(value) {
        this.tipoRegistro = value === 0 ? 'capacitador' : 'institucion'
      },
    },

    searchPlaceholder() {
      return this.tipoRegistro === 'capacitador'
        ? 'Buscar capacitador por nombre...'
        : 'Buscar institución responsable...'
    },

    capacitadores() {
      return this.registrosCapacitadores.filter((capacitador) => !this.isInstitucion(capacitador))
    },

    institucionesResponsables() {
      return this.registrosCapacitadores.filter((capacitador) => this.isInstitucion(capacitador))
    },

    filteredCapacitadores() {
      const search = this.buscaCapacitador.toLowerCase()

      return this.capacitadores.filter((capacitador) => {
        return [capacitador.nombre, capacitador.segundoNombre, capacitador.apaterno, capacitador.amaterno].some(
          (value) => (value || '').toLowerCase().indexOf(search) >= 0
        )
      })
    },

    filteredInstitucionesResponsables() {
      const search = this.buscaCapacitador.toLowerCase()

      return this.institucionesResponsables.filter((institucion) => {
        return (institucion.nombre || '').toLowerCase().indexOf(search) >= 0
      })
    },

    sortedCapacitadores() {
      return this.sortItems(this.filteredCapacitadores, 'apaterno')
    },

    sortedInstitucionesResponsables() {
      return this.sortItems(this.filteredInstitucionesResponsables, 'nombre')
    },

    currentItems() {
      return this.tipoRegistro === 'capacitador' ? this.sortedCapacitadores : this.sortedInstitucionesResponsables
    },

    currentHeaders() {
      return this.tipoRegistro === 'capacitador' ? this.capacitadoresHeaders : this.institucionesHeaders
    },

    emptyMessage() {
      return this.tipoRegistro === 'capacitador'
        ? 'No hay capacitadores registrados'
        : 'No hay instituciones responsables registradas'
    },
  },

  methods: {
    isInstitucion(capacitador) {
      return capacitador.apaterno === '-' && capacitador.amaterno === '-'
    },

    sortItems(items, field) {
      return [...items].sort((a, b) => {
        const aValue = ((a[field] || '') + '').toUpperCase()
        const bValue = ((b[field] || '') + '').toUpperCase()

        if (aValue < bValue) {
          return this.ordenAlfabetico === 0 ? -1 : 1
        }

        if (aValue > bValue) {
          return this.ordenAlfabetico === 0 ? 1 : -1
        }

        return 0
      })
    },
  },
}
</script>

<style scoped>
.trainers-shell {
  min-height: calc(100vh - 64px);
  min-height: calc(100dvh - 64px);
}

/* Estilos modernos para Capacitadores de Profesionalización */

/* Input de búsqueda */
::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(0, 210, 160, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(0, 210, 160, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field input::placeholder {
  color: rgba(224, 224, 224, 0.5) !important;
}

::v-deep .ui-form-field .v-label,
::v-deep .ui-form-field .mdi-magnify {
  color: rgba(38, 222, 129, 0.75) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label {
  color: #26de81 !important;
}

/* Botón toggle de orden */
::v-deep .v-btn-toggle {
  background: rgba(26, 46, 36, 0.6) !important;
  border: 1px solid rgba(0, 210, 160, 0.2);
  border-radius: 12px;
}

::v-deep .v-btn-toggle .v-btn {
  border-radius: 12px !important;
}

::v-deep .v-btn-toggle .v-btn--active {
  background: rgba(0, 210, 160, 0.2) !important;
}

/* Títulos y textos */
.text-h6,
.text-h4 {
  color: #e0e0e0 !important;
  font-weight: 700;
}

.secondary--text {
  color: #26de81 !important;
}

.primary--text {
  color: #e0e0e0 !important;
}

/* Expansion Panels */
::v-deep .v-expansion-panel {
  background: rgba(26, 46, 36, 0.4) !important;
  border: 1px solid rgba(0, 210, 160, 0.15);
  border-radius: 16px !important;
  margin-bottom: 12px;
  transition: all 0.3s ease;
}

::v-deep .v-expansion-panel:hover {
  background: rgba(26, 46, 36, 0.6) !important;
  border-color: rgba(0, 210, 160, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 210, 160, 0.2);
}

::v-deep .v-expansion-panel-header {
  color: #e0e0e0 !important;
  padding: 20px 24px;
  border-radius: 16px !important;
}

::v-deep .v-expansion-panel-header:hover {
  background: rgba(0, 210, 160, 0.08) !important;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 16px 24px 24px;
}

/* Cards de capacitadores */
::v-deep .v-card {
  background: rgba(26, 46, 36, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 210, 160, 0.2);
  border-radius: 16px;
  transition: all 0.3s ease;
}

::v-deep .v-card:hover {
  border-color: rgba(0, 210, 160, 0.4);
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 12px 32px rgba(0, 210, 160, 0.3) !important;
}

::v-deep .v-card-title {
  color: #e0e0e0 !important;
  padding: 16px;
  background: rgba(0, 210, 160, 0.08);
  border-bottom: 1px solid rgba(0, 210, 160, 0.2);
}

::v-deep .v-card-text {
  color: #e0e0e0 !important;
}

::v-deep .ui-module-table.no-table-bg.v-data-table,
::v-deep .ui-module-table.no-table-bg.theme--light.v-data-table,
::v-deep .ui-module-table.no-table-bg.theme--dark.v-data-table {
  background: transparent !important;
  background-color: transparent !important;
  background-image: none !important;
}

::v-deep .ui-module-table.no-table-bg > .v-data-table__wrapper,
::v-deep .ui-module-table.no-table-bg > .v-data-table__wrapper > table,
::v-deep .ui-module-table.no-table-bg .v-data-footer,
::v-deep .ui-module-table.no-table-bg tbody,
::v-deep .ui-module-table.no-table-bg tr,
::v-deep .ui-module-table.no-table-bg td {
  background: transparent !important;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none !important;
}

::v-deep .ui-module-table.no-table-bg > .v-data-table__wrapper > table > thead,
::v-deep .ui-module-table.no-table-bg .v-data-table-header,
::v-deep .ui-module-table.no-table-bg th {
  background: linear-gradient(135deg, rgba(0, 210, 160, 0.18) 0%, rgba(0, 210, 160, 0.1) 100%) !important;
  background-color: rgba(0, 210, 160, 0.12) !important;
}

::v-deep .ui-module-table.no-table-bg tbody tr:hover {
  background: transparent !important;
  background-color: transparent !important;
}

::v-deep .v-card-actions {
  background: rgba(0, 210, 160, 0.08) !important;
  border-top: 1px solid rgba(0, 210, 160, 0.1);
}

/* Avatares */
::v-deep .v-avatar {
  border: 2px solid rgba(0, 210, 160, 0.3);
  transition: all 0.3s ease;
  background: rgba(0, 210, 160, 0.15) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

::v-deep .v-card:hover .v-avatar {
  transform: rotate(5deg) scale(1.1);
  border-color: #00d2a0;
  box-shadow: 0 8px 24px rgba(0, 210, 160, 0.4);
}

::v-deep .v-avatar .v-icon {
  color: #26de81 !important;
  filter: drop-shadow(0 4px 12px rgba(0, 210, 160, 0.4));
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 210, 160, 0.6) !important;
}

::v-deep .v-btn.secondary {
  background: linear-gradient(135deg, #00d2a0 0%, #26de81 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(0, 210, 160, 0.4) !important;
}

::v-deep .v-btn.primary {
  background: rgba(26, 46, 36, 0.8) !important;
  border: 1px solid rgba(0, 210, 160, 0.3);
}

::v-deep .v-btn.primary:hover {
  background: rgba(26, 46, 36, 0.95) !important;
  border-color: #00d2a0;
}

::v-deep .v-btn.secondary--text {
  color: #00d2a0 !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.2);
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(26, 46, 36, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 210, 160, 0.3);
  border-radius: 8px;
  color: #e0e0e0 !important;
  font-weight: 500;
  padding: 8px 12px;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 210, 160, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 210, 160, 0.6);
}
</style>
